import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { compose, withApollo } from "react-apollo";
import { Table, Button, Breadcrumb, notification } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import { AdminsAndEditorsQuery, DeleteAdminMutation, DeleteEditorMutation } from './queries';

class List extends Component {

  render() {
    const { client } = this.props;
    const { loading, error, Users } = this.props.data;

    if (error) return `Error: ${error}`;

    const columns = [
      {
        title: 'Email',
        dataIndex: 'email',
        sorter: (a, b) => a.email.localeCompare(b.email),
      },
      {
        title: 'Role',
        dataIndex: 'role',
        sorter: (a, b) => a.role.toLowerCase().localeCompare(b.role.toLowerCase()),
      },
      {
        title: '',
        dataIndex: 'deleteButton',
        render: (_, user) => (
          <Button ghost onClick={() => {
            const mutation = user.role === 'admin' ? DeleteAdminMutation : DeleteEditorMutation;
            client.mutate({
              mutation,
              variables: { userId: user._id },
              refetchQueries: [{ query: AdminsAndEditorsQuery, variables: { 
                filter: {
                  "role": { "$in": [ "editor", "admin" ] }
                }}
              }],
            }).catch(error => notification.error(error));
          }} type="danger">
            <AntIcon type="delete" />Delete
          </Button>
        ),
      },
    ];

    return (
      <div id="catalog-list">
        <Breadcrumb>
          <Breadcrumb.Item>Editors</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <h4>
            Manage Editors
            <Button.Group size="small" className="is-right">
              <Button>
                <Link to="/editors/new"><AntIcon type="plus" /> New Editor</Link>
              </Button>
            </Button.Group>
          </h4>

          <Table
            scroll={{ x: 500 }}
            columns={columns}
            loading={null ? false : loading}
            dataSource={Users}
            rowKey='_id'
            pagination={{
              pageSize: 30,
              showTotal: (total) => `Total ${total} items`,
            }}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  graphql( AdminsAndEditorsQuery, { 
    options: { 
      variables: { 
        filter: {
          "role": { "$in": [ "editor", "admin" ] }
        }
      },
      fetchPolicy: 'cache-and-network',
    }
  }), withApollo)(List);
